module.exports = {
  AUTHORS_BLOCK: 'authors-block',
  TABLE_OF_CONTENTS: 'table-of-contents',
};
